import { render, staticRenderFns } from "./PermissionsErrorLayout.vue?vue&type=template&id=5652e601"
import script from "./PermissionsErrorLayout.vue?vue&type=script&lang=ts"
export * from "./PermissionsErrorLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports